export const deleteWatchlist = async (userId, list) => {
    try {
        await fetch('/api/watchlist/delete-watchlist', {
            method: 'DELETE',
            body: JSON.stringify({
                userId,
                list,
            })
        });
    } catch (error) {
        console.error(error);
    }
}